import App from "./App.svelte"

const app = new App({
  target: document.getElementById("mainContent"),
})

export default app
